import React from "react"
import Layout3 from './../components/layout/layout-3';
import SEO from './../components/seo/seo'
import Splittable from "../components/splittable";



const SplittablePage = () => (
  <Layout3>
    <SEO title="Splittable" />
    <Splittable />
  </Layout3>
)

export default SplittablePage
